import ApiService from '@/services/api.service'


const MdDrugFreqSetupHdrsService = {
    getAll(parameter) {          
      const requestData = {
        method: 'get',
        url: "/DrugFrequencyHeaders/",
        headers: {
        },
        params: { 
          SearchCriteria: parameter.SearchCriteria,
          PageSize: parameter.PageSize,          
          PageNumber : parameter.PageNumber, 
          Mode : parameter.Mode        
        }
      }     
      return ApiService.customRequest(requestData);         
    },
  
    get(id) {
      return ApiService.get(`/DrugFrequencyHeaders/${id}`);
    },

    FrequencyIsInUse(FreqCode) {
      return ApiService.get(`/DrugFrequencyHeaders/FrequencyIsInUse/${FreqCode}`);
    },

    ExistCode(FreqCode) {
      return ApiService.get(`/DrugFrequencyHeaders/ExistCode/${FreqCode}`);
    },

    add(data){
      return ApiService.post(`/DrugFrequencyHeaders`,data)
    },

    delete(id){
      return ApiService.delete(`/DrugFrequencyHeaders/${id}`)
    },
    
    update(id,data){
      return ApiService.put(`/DrugFrequencyHeaders/${id}`,data)
    },
   
}
  
  export default MdDrugFreqSetupHdrsService;